<template>
  <div
    id="app"
    :style="{ 'background-color': appStyle ? 'rgba(249,250,251,1)' : '#fff' }"
  >
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    appStyle() {
      let routerList = ["login", "index", "phoneRegister", "registered"];
      return !routerList.includes(this.$route.name);
    }
  }
};
</script>
